import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogOverlay as AlertDialogOverlayBase } from "./base/AlertDialogBase"

export type AlertDialogOverlayProps = ComponentProps<
  typeof AlertDialogOverlayBase
>

function AlertDialogOverlay(props: AlertDialogOverlayProps) {
  const { className, ...alertDialogOverlayBaseProps } = props

  return (
    <AlertDialogOverlayBase
      className={cn("ui-alert-dialog-overlay", className)}
      {...alertDialogOverlayBaseProps}
    />
  )
}

export default AlertDialogOverlay
